import {
  Box, Card, CardBody, CardHeader,
  Table, Tbody, Td, Text, Th, Thead, Tr,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import TableFallback from '../../Components/Loader/TableFallback';
import { useGetFormsQuery } from '../../Services/apiSlice';

const FormList = () => {
  const rta = useGetFormsQuery();
  return (
    <Card p="0px" maxW={{ sm: '320px', md: '100%' }}>
      <CardHeader>
        <Text color="gray.400" fontSize="sm" fontWeight="bold" mb="6px">
          FORM LIST
        </Text>
        <Text color="gray.700" fontSize="lg" fontWeight="bold">
          Most recent forms
        </Text>
      </CardHeader>
      <CardBody pt="0">
        <Box minH="300px">
          <Table color="gray.700">
            <Thead>
              <Tr>
                <Th borderColor="gray.200" w="70%">
                  Form Name
                </Th>
                <Th borderColor="gray.200">Submissions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {(rta.isFetching || rta.error) ? <TableFallback cols={2} />
                : rta.data.slice(0, 4).map((form, idx) => (
                  <Tr key={idx} color="gray.500">
                    <Td>
                      <Text fontWeight="bold">
                        <Link to={`/form/${form.id}`} state={{ title: form.name }}>{form.name}</Link>
                      </Text>
                    </Td>
                    <Td textAlign="end">{form.submissions}</Td>
                  </Tr>
                ))}
            </Tbody>
          </Table>
        </Box>
      </CardBody>
    </Card>

  );
};
export default FormList;
